import React from "react";
import { Search, PenTool, Settings, CheckCircle2 } from "lucide-react";
import { processSteps } from "../mock";
import { Reveal } from "../hooks/useReveal";

const icons = [Search, PenTool, Settings, CheckCircle2];

export default function Process() {
  return (
    <section id="process" className="bg-[var(--cream)]" style={{ backgroundColor: "var(--cream)" }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <Reveal className="mb-16 md:mb-20 max-w-3xl">
          <p className="font-sans-ui tracking-wide-2 text-[0.66rem] uppercase mb-6" style={{ color: "var(--teal)" }}>
            Our process
          </p>
          <h2 className="font-serif-display text-[2.4rem] md:text-[3.4rem] leading-[1.08] font-300 text-[var(--navy)]" style={{ color: "var(--navy)" }}>
            A considered path from first idea to lasting value
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-4 gap-px bg-[var(--sand)]/40" style={{ backgroundColor: "rgba(201,188,162,0.4)" }}>
          {processSteps.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={s.step} delay={i * 100} className="bg-[var(--cream)] p-8 md:p-10 group hover:bg-white transition-colors duration-500">
                <div className="flex items-center justify-between mb-8">
                  <span className="h-12 w-12 rounded-full border flex items-center justify-center transition-colors duration-500 group-hover:bg-[var(--navy)]" style={{ borderColor: "var(--teal)" }}>
                    <Icon size={18} strokeWidth={1.4} style={{ color: "var(--navy)" }} className="group-hover:!text-[var(--cream)] transition-colors duration-500" />
                  </span>
                  <span className="font-serif-display text-3xl" style={{ color: "var(--sand)" }}>{s.step}</span>
                </div>
                <h3 className="font-sans-ui tracking-wide-3 text-sm uppercase mb-4 text-[var(--navy)]" style={{ color: "var(--navy)" }}>{s.title}</h3>
                <p className="text-sm leading-relaxed text-[var(--muted)]" style={{ color: "var(--muted)" }}>{s.description}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
